export default {
    path: '/routers/routersAdd',
    name: 'RoutersAdd',
    component: () => import(/* webpackChunkName: "routersAdd" */ '../../views/routers/components/routersAdd.vue')
}